import React from "react";
import AirportSelector from "../../../../../../components/common/AirportSelector";
import "../../../../../../components/common/EditableCellGrid/EditableCellGrid.css";
import { useAirports } from "../../../../../../hooks/useReferenceData";

const AirportCellEditor = ({ row, column, onRowChange, onClose }) => {
    const { airportsList } = useAirports();
    const rawKey = column.key === "departureAirport" ? "departure_airport" : "arrival_airport";

    return (
        <AirportSelector
            autoFocus
            open
            allowClear
            valueType="iata_code"
            displayMode="simple"
            airports={airportsList}
            className="editable-cell-editor schedule-draft-rdg-editor-select"
            value={row[column.key] || undefined}
            onChange={(value) => {
                onRowChange({ ...row, [column.key]: value || "", rawFlight: { ...(row.rawFlight || {}), [rawKey]: value || "" } }, true);
                onClose(true, true);
            }}
            onInputKeyDown={(event) => {
                if (event.key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                    onClose(false, false);
                }
            }}
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
            getPopupContainer={() => document.body}
            popupMatchSelectWidth={false}
        />
    );
};

export default AirportCellEditor;
